const host = process.env.REACT_APP_BACKEND_URL_VAR || window.location.origin;
const api = `${host}/api`;
const account = `${api}/account/current`;
const token = `${host}/oauth/token`;
const confirmEmail = `${api}/account/confirmation/email`;
const confirmEmailResend = `${api}/account/confirmation/email/request`;
const registerRestaurateur = `${api}/user/restaurateur`;
const restaurant = `${api}/restaurant`;
const logout = `${api}/logout`;
const restaurantTable = `${api}/restaurant-table/restaurant`;
const restaurateur = `${api}/restaurateur`;
const restaurateurBooking = `${restaurateur}/booking`;
const restaurantWidget = `${api}/restaurant-widget`;
const bookingJournal = `${restaurateur}/restaurant`;
const statistic = `${restaurateur}/restaurant`;
const statisticSummary = `${statistic}`;
const statisticPie = `${statistic}`;
const statisticGuest = `${statistic}`;
const userInfo = `${api}/user/phone`;
const websocket = `${host}/websocket`;
const programs = `${api}/program`;
const loadsPrograms = `${programs}/restaurant`;
const menuRestaurant = `${api}/menu/restaurant`;
const restaurantSchedule = `${api}/restaurant-schedule`;
const restaurantScheduleGroup = `${restaurantSchedule}/group`;
const restaurantScheduleGroups = `${restaurantSchedule}/groups`;
const restaurantScheduleExclusions = `${restaurantSchedule}/group/common-with-exclusion`;
const restorePasswordInit = `${api}/account/reset-password/init`;
const restorePasswordFinish = `${api}/account/reset-password/finish`;
const sendConfirmCode = `${api}/account/confirmation/code/request`;
const widgetBooking = `${api}/widget/booking`;
const restaurantCalls = `${api}/restaurant`;
const prepaySettings = (restaurantId) => `${api}/restaurant/${restaurantId}/settings/prepay`;
const calculatedPrepay = (restaurantId, params) => `${api}/prepay/restaurant/${restaurantId}/prepay/calculate?${params}`;
const getPremiumBonus = (restaurantId, phone) => `${api}/restaurateur/restaurant/${restaurantId}/booking/statistic/guest/info/premium-bonus?guest-phone=${phone}`;
const discoverPremiumBonus = (restaurantId) => `${api}/restaurant/${restaurantId}/premium-bonus/integration/discover`;
const connectPremiumBonus = (restaurantId) => `${api}/restaurant/${restaurantId}/premium-bonus/integration`;

export {
  account,
  bookingJournal,
  confirmEmail,
  confirmEmailResend,
  logout,
  loadsPrograms,
  menuRestaurant,
  programs,
  restaurant,
  restaurateur,
  restaurateurBooking,
  restaurantTable,
  restaurantSchedule,
  restaurantScheduleGroup,
  restaurantScheduleGroups,
  restaurantScheduleExclusions,
  restaurantWidget,
  registerRestaurateur,
  restorePasswordInit,
  restorePasswordFinish,
  statistic,
  statisticSummary,
  statisticPie,
  statisticGuest,
  sendConfirmCode,
  token,
  userInfo,
  websocket,
  widgetBooking,
  restaurantCalls,
  prepaySettings,
  calculatedPrepay,
  getPremiumBonus,
  discoverPremiumBonus,
  connectPremiumBonus
};
